import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { LongFormPlayground } = await import('./index');
    return {
        Component: LongFormPlayground,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
